import {ParamKey} from '../../../../store/dashboard';
import {KeyPerformanceIndicatorRequest} from '../../../../store/analytics/types/key-performance-indicator.types';
import {KpiTypes} from '../../../../store/analytics';
import {ControlsSnapshot} from '../../dashboard-controls/controls-snapshot';
import {createDateRangeWithFunctionalLocationsRequest} from '../utils/widget-helper';
import {CurrencyInfo} from '../../../../store/fleet-customers';

export function buildRequest(snapshot: ControlsSnapshot, type: KpiTypes, currency: CurrencyInfo): KeyPerformanceIndicatorRequest {
    return Object.assign(
        createDateRangeWithFunctionalLocationsRequest(snapshot), {
            type,
            currency
        });
}

export function isValidSnapshot(snapshot: ControlsSnapshot): boolean {
    return snapshot.has(ParamKey.InspectionPeriod);
}
